module.exports = __webpack_public_path__ + "static/media/lesson-menu@2x1.9fe463c3.png";